export default __webpack_public_path__ + "static/media/RamLanding.74a18c4d.png";